import React, { useState, useEffect } from "react";
import news from "./news.module.css";
import imgI from "../../img/img11.png";
import imgII from "../../img/img12.png";
import imgIII from "../../img/img13.png";
import imgIV from "../../img/img14.png";
import { Link } from "react-router";
import { fetchAllPosts, imageUrl, getAllTechTv } from "../../Api/PostManApi";
const WorldNews = () => {
  const [techTv, setTechTv] = useState([]);
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      const [postResponse, tvResponse] = await Promise.all([
        fetchAllPosts(),
        getAllTechTv(),
      ]);
      const postsArray = Array.isArray(postResponse)
        ? postResponse
        : postResponse.data && Array.isArray(postResponse.data.posts)
        ? postResponse.data.posts
        : [];
      if (postsArray.length > 0) {
        console.log("this is only tech tv", tvResponse);
        setTechTv(tvResponse.data);
        setPosts(postsArray.slice(3, 7));
      }
    };
    fetchPosts();
  }, []);
  return (
    <div className={news.news}>
      <div className={news.container}>
        <div className={news.content}>
          <div className={news.flexI}>
            <button>World News</button>
            {posts.map((post) => (
              <div className={news.blockI}>
                <Link to={`/${post?.slug}`} state={{ source: "A" }}>
                  <img
                    src={`${imageUrl}/post_images/${post.images}`}
                    alt={post.title || "Post image"} // Always good to have proper alt text
                    style={{
                      height: "150px",
                      width: "100%", // Maintains aspect ratio
                      objectFit: "cover", // Ensures image fills space without distortion
                    }}
                  />
                  <p>{post?.title} </p>
                </Link>
              </div>
            ))}

            <div className={news.blockII}>
              <p>ADS POST</p>
            </div>
          </div>
          <div className={news.flexII}>
            <div className={news.secI}>
              <button>Techpression TV</button>
              <p>{techTv[1]?.title}</p>
              <div className={news.vid}>
                <iframe
                  width="560"
                  height="315"
                  src={techTv[1]?.url}
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; 
                        // web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
            <div className={news.secII}>
              <div className={news.vidI}>
                <div className={news.yout}>
                  <iframe
                    width="400"
                    height="315"
                    src={techTv[2]?.url}
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>
                <p>{techTv[2]?.title}</p>
              </div>
              <div className={news.vidII}>
                <div className={news.yout}>
                  <iframe
                    width="400"
                    height="315"
                    src={techTv[3]?.url}
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen
                  ></iframe>
                </div>
                <p>{techTv[3]?.title}</p>
              </div>
            </div>
          </div>
        </div>
        <div className={news.contentII}>
          <div className={news.blockIV}>
            ` <h1>GOOGLE ADSENSE POSTS</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorldNews;
